import $ from 'jquery'

class Search {
  // 1. Describe and create or initiate our object
  constructor() {
    this.addSearchHTML()
    this.resultsDiv = $('#search-overlay__results')
    this.openButton = $('.js-search-trigger')
    this.closeButton = $('.search-overlay__close')
    this.searchOverlay = $('.search-overlay')
    this.searchField = $('#search-term')
    this.events()
    this.isOverlayOpen = false
    this.isSpinnerVisible = false
    this.previousValue
    this.typingTimer
  }

  // 2. Events
  events() {
    this.openButton.on('click', this.openOverlay.bind(this))
    this.closeButton.on('click', this.closeOverlay.bind(this))
    $(document).on('keydown', this.keyPressDispatcher.bind(this))
    this.searchField.on('keyup', this.typingLogic.bind(this))
  }

  // 3. Methods (function, action...)
  typingLogic() {
    if (this.searchField.val() != this.previousValue) {
      clearTimeout(this.typingTimer)
      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html('<div class="spinner-loader"></div>')
          this.isSpinnerVisible = true
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750)
      } else {
        this.resultsDiv.html('')
        this.isSpinnerVisible = false
      }
    }

    this.previousValue = this.searchField.val()
  }

  getResults() {
    if (!this.isSpinnerVisible) {
      this.resultsDiv.html('<div class="spinner-loader"></div>')
      this.isSpinnerVisible = true
    }
    $.getJSON(mediastapData.root_url + '/wp-json/mediastap/v1/search?term=' + this.searchField.val(), results => {
      this.resultsDiv.html(`
        ${results.generalInfo.length ? '<div class="row"><div class="col-12"><h2 class="search-overlay__section-title mb-4 mt-5">Algemene Informatie</h2></div></div><div class="row">' : ''}
          ${results.generalInfo
            .slice(0, 8)
            .map(
              item => `
              <div class="col-md-3 mb-4">
                <div class="card">
                  <img src="${item.image}" class="card-img-top" alt="${item.title}">
                  <div class="card-body">
                  <div class="card-category">${item.postType == 'post' ? `${item.category}` : 'Pagina'}</div>
                    <h5 class="card-title">${item.title}</h5>
                    <p class="card-text">${item.description}</p>
                    <a href="${item.permalink}" class="stretched-link">Meer lezen</a>
                  </div>
                </div>
              </div>`
            )
            .join('')}
        ${results.generalInfo.length ? '</div>' : ''}
        
        ${results.projecten.length ? '<div class="row"><div class="col-12"><h2 class="search-overlay__section-title mb-4 mt-5">Projecten</h2></div></div><div class="row">' : ''}
          ${results.projecten
            .slice(0, 8)
            .map(
              item => `
              <div class="col-md-3 mb-4">
                <div class="card">
                  <img src="${item.image}" class="card-img-top" alt="${item.title}">
                  <div class="card-body">
                  <div class="card-category">${item.category}</div>
                    <h5 class="card-title">${item.title}</h5>
                    <p class="card-text">${item.description}</p>
                    <a href="${item.permalink}" class="stretched-link">Meer lezen</a>
                  </div>
                </div>
              </div>`
            )
            .join('')}
        ${results.projecten.length ? '</div>' : ''}
        
        ${results.team.length ? '<div class="row"><div class="col-12"><h2 class="search-overlay__section-title mb-4 mt-5">Team</h2></div></div><div class="row">' : ''}
          ${results.team
            .slice(0, 8)
            .map(
              item => `
              <div class="col-md-3 mb-4">
                <div class="card team-card">
                  <img src="${item.image}" class="card-img-top" alt="${item.title}">
                  <div class="card-body">
                    <h5 class="card-title">${item.name}</h5>
                    <p class="card-text">${item.jobtitle}</p>
                    <div class="team-contact">${item.email ? `<a href="mailto:${item.email}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/></svg></a>` : ''}${item.linkedin ? `<a href="${item.linkedin}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/></svg></a>` : ''}${item.phone ? `<a href="${item.phone}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16"><path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/><path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/></svg></a>` : ''}</div>
                  </div>
                </div>
              </div>`
            )
            .join('')}
        ${results.projecten.length ? '</div>' : ''}
      
        ${results.vacatures.length ? '<div class="row"><div class="col-12"><h2 class="search-overlay__section-title mb-4 mt-5">Vacatures</h2></div></div><div class="row">' : ''}
          ${results.vacatures
            .slice(0, 8)
            .map(
              item => `
              <div class="col-md-3 mb-4">
                <div class="card">
                  <img src="${item.image}" class="card-img-top" alt="${item.vac_title}">
                  <div class="card-body">
                  <div class="card-category">Vacature</div>
                    <h5 class="card-title">${item.vac_title}</h5>
                    <p class="card-text">${item.description}</p>
                    <a href="${item.permalink}" class="stretched-link">Meer lezen</a>
                  </div>
                </div>
              </div>`
            )
            .join('')}
        ${results.vacatures.length ? '</div>' : ''}
      `)
      this.isSpinnerVisible = false
    })
  }

  keyPressDispatcher(e) {
    if (e.keyCode == 83 && !this.isOverlayOpen && !$('input, textarea').is(':focus')) {
      this.openOverlay()
    }
    if (e.keyCode == 27 && this.isOverlayOpen) {
      this.closeOverlay()
    }
  }

  openOverlay() {
    this.searchOverlay.addClass('search-overlay--active')
    document.body.style.overflowY = 'hidden'
    this.searchField.val('')
    setTimeout(() => this.searchField.focus(), 301)
    console.log('Open')
    this.isOverlayOpen = true
    return false
  }

  closeOverlay() {
    this.searchOverlay.removeClass('search-overlay--active')
    document.body.style.overflowY = 'hidden'
    console.log('Close')
    this.isOverlayOpen = false
  }

  addSearchHTML() {
    $('#menu').append(`
      <div class="search-overlay">
        <div class="search-overlay__top">
          <div class="container-xxl">
            <div class="row">
              <div class="col-12 search-overlay__top__content">
                <i class="fa fa-search search-overlay__icon" aria-hidden="true"></i>
                <input type="text" class="search-term" placeholder="Waar zoekt u naar?" id="search-term">
                <i class="fa fa-window-close search-overlay__close" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="container-xxl" id="search-overlay__results">
          
        </div>
      </div>
    `)
  }
}
export default Search
